/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Coaching_Invite_SentInputs */

const en_us2_coaching_invite_sent = /** @type {(inputs: Coaching_Invite_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invitation sent to ${i?.email}.`)
};

const pt_br2_coaching_invite_sent = /** @type {(inputs: Coaching_Invite_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convite enviado para ${i?.email}.`)
};

const pt_pt2_coaching_invite_sent = /** @type {(inputs: Coaching_Invite_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convite enviado para ${i?.email}.`)
};

/** @type {(inputs: Coaching_Invite_SentInputs) => LocalizedString} */
const es_419_coaching_invite_sent = en_us2_coaching_invite_sent;

/** @type {(inputs: Coaching_Invite_SentInputs) => LocalizedString} */
const fr_fr2_coaching_invite_sent = en_us2_coaching_invite_sent;

/** @type {(inputs: Coaching_Invite_SentInputs) => LocalizedString} */
const de_de2_coaching_invite_sent = en_us2_coaching_invite_sent;

/** @type {(inputs: Coaching_Invite_SentInputs) => LocalizedString} */
const it_it2_coaching_invite_sent = en_us2_coaching_invite_sent;

/**
* | output |
* | --- |
* | "Invitation sent to {email}." |
*
* @param {Coaching_Invite_SentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_invite_sent = /** @type {((inputs: Coaching_Invite_SentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Invite_SentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_invite_sent(inputs)
	if (locale === "es-419") return es_419_coaching_invite_sent(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_invite_sent(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_invite_sent(inputs)
	if (locale === "de-DE") return de_de2_coaching_invite_sent(inputs)
	if (locale === "it-IT") return it_it2_coaching_invite_sent(inputs)
	return en_us2_coaching_invite_sent(inputs)
});
export { coaching_invite_sent as "coaching.invite_sent" }